

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, FormItem, Input, Option, Select } from 'element-ui';
import BillItemSelect from '@/components/modals/BillItemSelect.vue';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';

// options
import { currencyOptions } from '@/constants/currencyOptions.ts';
import { taxTypeOptions } from '@/constants/taxTypeOptions.ts';

// gql
import ShipmentBillItemsQuery from '@/graphql/queries/billItem/ShipmentBillItems.gql';

// types
import {
  BillItemFields,
  CurrencyEnum,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    shipmentBillItems: {
      query: ShipmentBillItemsQuery,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update(data) {
        // set exchange rate
        this.usdJpyExchangeRate = data?.shipments[0].usdJpyExchangeRate;
        // return bill items only
        return data?.shipments[0].billItems.filter(item => !item.isSection) || [];
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    }
  },
  components: {
    BillItemSelect,
    NullableNumberInput,
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class FreightDeliveryInformation extends Vue {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  // bill items from the shipment don't edit
  shipmentBillItems: BillItemFields[] = [];
  openEditModal = false;

  readonly currencyOptions = currencyOptions();
  readonly taxTypeOptions = taxTypeOptions();

  readonly CurrencyEnum = CurrencyEnum;

  get billItems() {
    return this.value.billItems;
  }

  set billItems(data) {
    this.$emit('input', { ...this.value, billItems: data });
  }

  deleteItem(index) {
    this.billItems.splice(index, 1);
  }

  updateSelecedItems(selectedItems: string[]) {
    // loop over selected item and push only new item.
    selectedItems.forEach(item => {
      const index = this.billItems.map(i => { return i.id; }).indexOf(item);
      // new item
      if (index === -1) {
        // find the item from the shipment's billitem and bind the values
        const sourceItem = this.shipmentBillItems[this.shipmentBillItems.map(i => { return i.id; }).indexOf(item)];

        this.billItems.push({
          id: sourceItem.id,
          unitPrice: sourceItem.unitPrice,
          description: sourceItem.description,
          quantity: sourceItem.quantity,
          taxRate: sourceItem.taxRate,
          category: sourceItem.category,
          displayCurrency: CurrencyEnum[sourceItem.currency],
          taxType: sourceItem.taxType
        });
      }
    });

    // delete
    // loop over items to find deleted one.
    const itemToDelete = [];

    this.billItems.forEach(item => {
      // find deleted item
      if (!selectedItems.includes(item.id)) {
        const index = this.shipmentBillItems.map(i => { return i.id; }).indexOf(item.id);

        // add item to delete list if item is found
        if (index !== -1) {
          itemToDelete.push(this.shipmentBillItems.map(i => { return i.id; }).indexOf(item.id));
        }
      }
    });

    // sort the array not to mess up the deletion
    itemToDelete.sort((a, b) => { return b - a; });
    // remove deleted items
    for (let i = itemToDelete.length - 1; i >= 0; i -= 1) {
      this.billItems.splice(itemToDelete[i], 1);
    }

    // emit value
    this.$emit('input', { ...this.value, billItems: this.billItems });
  }
}
